export default {
  id: "page14",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      label:
        "Które z poniższych produktów Pan(i) używał(a)?",
      number: "27"
    },
    {
      type: "choice_names",
      options: ["TAK", "NIE"],
      topLine: true,
      labelWidth: "is-three-fifths",
      bottomLine: true
    },
    {
      label: "Cukier z prawdziwą wanilią",
      type: "radio",
      id: "kategoria9_cukierWanilia",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Laska wanili",
      type: "radio",
      id: "kategoria9_laskaWanilii",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Szafran",
      type: "radio",
      id: "kategoria9_szafran",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Kardamon",
      type: "radio",
      id: "kategoria9_kardamon",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Cynamon",
      type: "radio",
      id: "kategoria9_cynamon",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Imbir",
      type: "radio",
      id: "kategoria9_imbir",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Ekstrakt naturalny waniliowy",
      type: "radio",
      id: "kategoria9_ekstraktWaniliowy",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Pasta waniliowa",
      type: "radio",
      id: "kategoria9_pastaWaniliowa",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Cukry smakowe, np. ze skórką pomarańczową, cytrynową itp.",
      type: "radio",
      id: "kategoria9_cukrySmakowe",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Inne ekstrakty naturalne, np. cytrynowy, pomarańczowy, migdałowy",
      type: "radio",
      id: "kategoria9_inneEkstrakty",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Przyprawa korzenna/ do piernika",
      type: "radio",
      id: "kategoria9_przyprawaKorzenna",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page14.js